// src/utils/phone.js
//
// Phone formatting helpers. Lifted out of NewCaseModal.vue so the
// wizard, the dashboard, and CompanyAccount-Indemnitor can all
// share one implementation.
//
// formatPhone(raw):    format-as-you-type for display. Strips to
//                      digits, drops leading 1 if 11 digits, formats
//                      US numbers as (XXX) XXX-XXXX. International
//                      numbers (starting with + but not +1) pass
//                      through unchanged.
//
// phoneToE164(display): convert a display-formatted phone to
//                      E.164 storage form (+1XXXXXXXXXX) or null
//                      if empty.

export function formatPhone(raw) {
  if (!raw) return '';
  if (raw.startsWith('+') && !raw.startsWith('+1')) return raw;
  let digits = raw.replace(/\D/g, '');
  if (digits.length === 11 && digits[0] === '1') digits = digits.slice(1);
  digits = digits.slice(0, 10);
  if (digits.length === 0) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

export function phoneToE164(display) {
  if (!display) return null;
  if (display.startsWith('+') && !display.startsWith('+1')) return display;
  const digits = display.replace(/\D/g, '');
  return digits ? `+1${digits}` : null;
}
